import {Component, Inject} from '@angular/core';
import {MxFormErrorMessageService} from '../../../../services/mx-form-error-message.service';
import {MxField} from '../../services/mxField';
import {MX_TRANSLATE_SERVICE_TOKEN, MxTranslateService} from '../../../../../../shared/services/mx-translate.service';

@Component({
    selector: 'mx-text-area-field',
    standalone: false,
    templateUrl: './mx-text-area-field.component.html'
})
export class MxTextAreaFieldComponent extends MxField {

    constructor(public errorService: MxFormErrorMessageService,
                @Inject(MX_TRANSLATE_SERVICE_TOKEN) protected translateService: MxTranslateService) {
        super(errorService, translateService);
    }
}
